import { Stats, ReportSummary } from '@snapi/types';
import { percentile } from '../stats';

const calculateDiversityScore = (
  diversity: number,
  stats: Pick<Stats, 'avg' | 'deviation'>
): number => percentile(diversity, stats) * 100;

const isGood = (score: number) => score > 15;

const summary = (
  diversity: number,
  diversityStats: Pick<Stats, 'avg' | 'deviation'>
): ReportSummary['diversity'] => {
  const score = diversityStats
    ? calculateDiversityScore(diversity, diversityStats)
    : 50;
  return {
    score,
    good: isGood(score),
  };
};

export const ReportDiversityUtils = {
  isGood,
  summary,
};
